import { GestaoAlertasComponent } from './pages/gestao-alertas.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { GestaoAlertasRoutingModule } from './gestao-alerta-routing.module';
import { RnpaPessoasModule } from '@modules/consulta/produtos/rnpa-pessoas/rnpa-pessoas.module';
import { ModalGestaoAlertasComponent } from './components/modal-gestao-alertas/modal-gestao-alertas.component';
import { ExcluirInativarAlertaDialogComponent } from './components/excluir-inativar-alerta-dialog/excluir-inativar-alerta-dialog.component';
import { AlertaFixoComponent } from './components/alerta-fixo/alerta-fixo.component';
import { CustomAlertaComponent } from './components/modal-alerta/custom-alerta.component';
import { AngularEditorModule } from '@kolkov/angular-editor';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        GestaoAlertasRoutingModule,
        RnpaPessoasModule,
        AngularEditorModule 
    ],
    declarations: [GestaoAlertasComponent, ModalGestaoAlertasComponent, ExcluirInativarAlertaDialogComponent, AlertaFixoComponent, CustomAlertaComponent],
    exports: [
        CustomAlertaComponent,
        AlertaFixoComponent
    ],
    providers: []
})
export class GestaoAlertasModule { }
